<template>
  <div>
    <v-btn
      v-if="$can('set-logistics-pending-status', 'Yacht')"
      color="primary"
      class="text-capitalize"
      text
      block
      rounded
      @click="$emit('update:status', yachtStatuses.STATUS_PENDING)"
    >
      <v-icon
        left
        small
      >
        arrow_forward
      </v-icon>
      Switch to Pending Plan
    </v-btn>
  </div>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'YachtDraft',
    data() {
      return {
        yachtStatuses: Yacht
      }
    }
  }
</script>
